import {
  FaHome,
  FaUser,
  FaHandHoldingWater,
  FaHeart,
  FaCss3Alt,
  FaLaravel,
  FaPhp,
  FaJava,
} from "react-icons/fa";
import { BsFillBuildingsFill, BsFiletypeSass, BsGit } from "react-icons/bs";
import {
  BiSolidContact,
  BiLogoReact,
  BiLogoTypescript,
  BiLogoRedux,
  BiLogoTailwindCss,
  BiLogoFigma,
  BiLogoNodejs,
  BiLogoMongodb,
  BiLogoFirebase,
  BiLogoNetlify,
} from "react-icons/bi";
import { TbBrandNextjs, TbBrandVscode } from "react-icons/tb";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import {
  SiStyledcomponents,
  SiExpress,
  SiCoronarenderer,
  SiPostman,
  SiNpm,
  SiVercel,
  SiJest,
  SiJira,
} from "react-icons/si";
import { DiBootstrap, DiMysql, DiJavascript } from "react-icons/di";
import { RxNotionLogo } from "react-icons/rx";

export const services = [
  {
    id: 1,
    en_title: "Software Development",
    de_title: "Webgestaltung",
    en_det:
      "I am crafting efficient and innovative solutions, leveraging my expertise in full-stack development to deliver high-quality software products",
    de_det:
      "Ich erarbeite effiziente und innovative Lösungen und nutze mein Fachwissen im Bereich Full-Stack-Entwicklung, um hochwertige Softwareprodukte zu liefern.",
    img: "chargeandco.png",
    icon: "web-icon.svg",
    bgIcon: "bg-[#fce7f3]",
  },
  {
    id: 2,
    en_title: "UX/UI Design",
    de_title: "UX/UI Gestaltung",
    en_det:
      "Use the Figma platform to provide the power of visuality and art to demonstrate your businesses",
    de_det:
      "Nutzen Sie die Figma-Plattform, um Ihr Unternehmen mit der Kraft der Visualität und der Kunst zu präsentieren",
    img: "d-img.png",
    icon: "design-icon.svg",
    bgIcon: "bg-[#a5f3fc]",
  },
  {
    id: 3,
    en_title: "Detabase Desgin",
    de_title: "Datenbank Entwurf",
    en_det:
      "Use MySql and MongoDB to design relational and non-relational databases in order to provide accuracy, consistency, and completeness of data",
    de_det:
      "Verwendung von MySql und MongoDB zur Entwicklung relationaler und nicht-relationaler Datenbanken, um die Genauigkeit, Konsistenz und Vollständigkeit von Daten zu gewährleisten",
    img: "database-image.png",
    icon: "database-icon.svg",
    bgIcon: "bg-[#d1fae5]",
  },
];

export const skillsCategory = [
  {
    id: 1,
    en_title: "Programming Languages",
    de_title: "Programmiersprachen",
    skills: [
      {
        id: 1,
        icon: <DiJavascript className="icon js" />,
        name: "JavaScript",
      },
      {
        id: 2,
        icon: <FaPhp className="icon html5" />,
        name: "PHP",
      },
      {
        id: 3,
        icon: <FaJava className="icon java" />,
        name: "Java",
      },
    ],
  },
  {
    id: 2,
    en_title: "Frontend Frameworks and Libraries",
    de_title: "Frontend Frameworks und Bibliotheken",
    skills: [
      {
        id: 1,
        icon: <AiFillHtml5 className="icon html5" />,
        name: "HTML5",
      },
      {
        id: 2,
        icon: <FaCss3Alt className="icon css3" />,
        name: "CSS3",
      },
      {
        id: 3,
        icon: <BiLogoReact className="icon reactjs" />,
        name: "ReactJS",
      },
      {
        id: 4,
        icon: <TbBrandNextjs className="icon nextjs" />,
        name: "NextJS",
      },
      {
        id: 5,
        icon: <BiLogoTypescript className="icon typescript" />,
        name: "TypeScript",
      },
      {
        id: 6,
        icon: <BiLogoRedux className="icon redux" />,
        name: "Redux",
      },
      {
        id: 7,
        icon: <BiLogoTailwindCss className="icon tailwind" />,
        name: "Tailwind",
      },
      {
        id: 8,
        icon: <BsFiletypeSass className="icon sass" />,
        name: "SASS",
      },
      {
        id: 9,
        icon: <DiBootstrap className="icon bootstrap" />,
        name: "Bootstrap",
      },
      {
        id: 10,
        icon: <SiStyledcomponents className="icon css-in-js" />,
        name: "CSS in JS",
      },
      {
        id: 11,
        icon: <BiLogoFigma className="icon figma" />,
        name: "Figma",
      },
    ],
  },
  {
    id: 3,
    en_title: "Backend Frameworks and Databases",
    de_title: "Backend Frameworks und Datenbanken",
    skills: [
      {
        id: 1,
        icon: <BiLogoNodejs className="icon nodejs" />,
        name: "NodeJS",
      },
      {
        id: 2,
        icon: <SiExpress className="icon expressjs" />,
        name: "ExpressJS",
      },
      {
        id: 3,
        icon: <FaLaravel className="icon laravel" />,
        name: "Laravel",
      },
      {
        id: 4,
        icon: <DiMysql className="icon mysql" />,
        name: "MySql",
      },
      {
        id: 5,
        icon: <BiLogoMongodb className="icon mongodb" />,
        name: "MonogDB",
      },
    ],
  },
  {
    id: 4,
    en_title: "Cloud Service Providers, Tools, and IDE",
    de_title: "Anbieter von Cloud-Diensten, Tools und IDE",
    skills: [
      {
        id: 1,
        icon: <BiLogoFirebase className="icon firebase" />,
        name: "Firebase",
      },
      {
        id: 2,
        icon: <SiVercel className="icon vercel" />,
        name: "Vercel",
      },
      {
        id: 3,
        icon: <BiLogoNetlify className="icon netlify" />,
        name: "Netlify",
      },
      {
        id: 4,
        icon: <SiCoronarenderer className="icon render" />,
        name: "Render",
      },
      {
        id: 5,
        icon: <BsGit className="icon git" />,
        name: "Git",
      },
      {
        id: 6,
        icon: <AiFillGithub className="icon github" />,
        name: "GitHub",
      },
      {
        id: 7,
        icon: <SiPostman className="icon postman" />,
        name: "Postman",
      },
      {
        id: 8,
        icon: <TbBrandVscode className="icon vscode" />,
        name: "VS Code",
      },
      {
        id: 9,
        icon: <SiNpm className="icon npm " />,
        name: "NPM",
      },
      {
        id: 10,
        icon: <SiJest className="icon jest" />,
        name: "JEST",
      },
      {
        id: 11,
        icon: <RxNotionLogo className="icon vscode" />,
        name: "Notion",
      },
      {
        id: 12,
        icon: <SiJira className="icon jira" />,
        name: "Jira",
      },
    ],
  },
];

export const menus = [
  {
    id: 1,
    icon: <FaHome className="menu-icon" />,
    label: "home",
    target: "#home",
  },
  {
    id: 2,
    icon: <FaHeart className="menu-icon" />,
    label: "favorites",
    target: "#favorites",
  },
  {
    id: 3,
    icon: <FaUser className="menu-icon" />,
    label: "about",
    target: "#about",
  },
  {
    id: 4,
    icon: <FaHandHoldingWater className="menu-icon" />,
    label: "services",
    target: "#services",
  },
  ,
  {
    id: 5,
    icon: <BsFillBuildingsFill className="menu-icon" />,
    label: "experiences",
    target: "#experiences",
  },
  {
    id: 6,
    icon: <BiSolidContact className="menu-icon" />,
    label: "contact",
    target: "#contact",
  },
];

export const navigation = [
  { id: 1, en_name: "Home", de_name: "Home", path: "#hero", nemuId: "hero" },
  { id: 3, en_name: "About", de_name: "Über", path: "#about", nemuId: "about" },
  {
    id: 4,
    en_name: "Experiences",
    de_name: "Erfahrungen",
    path: "#experiences",
    nemuId: "experiences",
  },
  {
    id: 5,
    en_name: "Contact",
    de_name: "Kontakt",
    path: "#contact",
    nemuId: "contact",
  },
];

export const projects = [
  {
    name: "Portfolio",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: "portfolio.png",
    source_code_link: "https://github.com/",
    live_demo_link: "",
  },
  {
    name: "Portofil",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: "portfolio.png",
    source_code_link: "https://github.com/",
  },
  {
    name: "Car Rent",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: "portfolio.png",
    source_code_link: "https://github.com/",
  },
  {
    name: "Car Rent",
    description:
      "Web-based platform that allows users to search, book, and manage car rentals from various providers, providing a convenient and efficient solution for transportation needs.",
    tags: [
      {
        name: "react",
        color: "blue-text-gradient",
      },
      {
        name: "mongodb",
        color: "green-text-gradient",
      },
      {
        name: "tailwind",
        color: "pink-text-gradient",
      },
    ],
    image: "portfolio.png",
    source_code_link: "https://github.com/",
  },
];
